import type { CurrentUser } from "../hooks/useAuthRestApi";

/**
 * 管理者権限が必要なページへのアクセス可否を判定する
 * 現在は特定のorganizationIdベースで判定（将来的にはisAdminフィールドを使用予定）
 * @param {CurrentUser | null} user - 現在のユーザー情報
 * @return {boolean} アクセス可能な場合はtrue
 */
export const canAccessAdminPages = (user: CurrentUser | null): boolean => {
  if (!user) return false;

  // 一時的な実装: 特定のorganizationIdを管理者として扱う
  // TODO: GraphQLスキーマにisAdminフィールドが追加されたら、user.isAdminを使用する
  const adminOrganizationIds = [
    "5cbf2941-be8b-4866-a6a9-9cac0b2ac723", // Tech Reis Dev (legacy)
    "323d67dc-1fb7-4931-97fc-263bdb48cf4b", // Tech Reis Prd (legacy)
    "e07d14f3-856d-4e65-8b12-542703d9e718", // Dev tenant (new tenantId)
  ];

  return user.organizationId
    ? adminOrganizationIds.includes(user.organizationId)
    : false;
};
